<ui-section [title]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CARD_TITLE.REPRESENTATION' | translate">
    <ui-section-actions>
        <div class="representation-icons">
            <ui-icon-button-toggle
                color="primary"
                [options]="representationList"
                [ngModel]="representationSelected()"
                [disabled]="disabled()"
                (ngModelChange)="changeRepresentation($event)"
            />
        </div>
    </ui-section-actions>
    <ui-section-content>
        <ng-container #formHost />
    </ui-section-content>
</ui-section>
